import { apiClient, TASK_STATUSES } from '../../../shared/api';

export const createTaskStatus = async (taskStatusData) => {
  const { name } = taskStatusData;

  const requestBody = {
    task_status: {
      name,
    },
  };

  const response = await apiClient.post(TASK_STATUSES, requestBody, {
    includeWebsite: true,
  });

  return response.data;
};

export const deleteTaskStatus = async (taskStatusId) => {
  await apiClient.delete(`${TASK_STATUSES}/${taskStatusId}`);
};

export const fetchTaskStatuses = async () => {
  const response = await apiClient.get(TASK_STATUSES, { includeWebsite: true });

  return response.data;
};

export const updateTaskStatus = async ({ taskStatusData, taskStatusId }) => {
  const requestBody = {
    task_status: taskStatusData,
  };

  const response = await apiClient.patch(`${TASK_STATUSES}/${taskStatusId}`, requestBody);

  return response.data;
};
